// src/modules/app-views/products/pages/Document/tabs/RecordTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import { useDocumentContext } from 'components/core/DocumentProvider';
import DocumentIdentifier from 'components/core/DocumentIdentifier';

// Card Components
import ProductCard from './ProductCard';
import ProductInfoCard from './ProductInfoCard';
import AlternativeNamesCard from './AlternativeNamesCard';
import ClassificationCard from './ClassificationCard';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ProductsRecordTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, loading } = useDocumentContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="productRecord" isFetching={loading} data={data} />

      {/* PRODUCT CARD */}
      <ProductCard />

      {/* PRODUCT INFO CARD */}
      <ProductInfoCard />

      {/* CLASSIFICATION CARD */}
      <ClassificationCard />

      {/* ALTERNATIVE NAMES CARD */}
      {/*<AlternativeNamesCard />*/}

      {/* Document Identifier (_id and Legacy Code) */}
      {/*<div style={{ marginTop: 8 }}>*/}
      {/*  <DocumentIdentifier documentId={data?._id} legacyCode={data?.legacyCode} />*/}
      {/*</div>*/}
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ProductsRecordTab;
